import mock from '../../axios'
import { paginateArray, sortCompare } from '../../utils'

/* eslint-disable global-require */
const data = {
  users: [
    {
      id: 1,
      fullName: 'Galen Slixby',
      role: 'lähihoitaja',
      love: 'suoritettu',
      preferences: ['päivä-työ', 'vain sairaanhoitaja työ'],
      permits: ['rokotus lupa', 'love'],
      birthDate: '28-07-1998',
      gender: 'female',
      languages: ['English', 'Arabic'],
      address: {
        add_line_1: 'Vallikallion kuja 5B',
        add_line_2: '',
        post_code: '02650',
        city: 'Espoo',
        state: 'Uusimaa',
        country: 'Finland',
      },
      bankDetails: {
        name: 'Halsey Redmore',
        IBAN: 'FI93943509340534095',
        BIC: 'OKOSDS',
        bank: 'OP',
      },
      mobile: '(479) 232-9151',
      carAvailable: true,
      drivingLicense: 'B',
      email: 'gslixby0@abc.net.au',
      status: 'rejected',
      avatar: '',
    },
    {
      id: 2,
      fullName: 'Halsey Redmore',
      company: 'Skinder PVT LTD',
      role: 'lähihoitaja',
      preferences: ['päivä-työ', 'vain sairaanhoitaja työ'],
      permits: ['rokotus lupa', 'love'],
      birthDate: '28-07-1998',
      gender: 'female',
      languages: ['English', 'Arabic'],
      address: {
        add_line_1: 'Vallikallion kuja 5B',
        add_line_2: '',
        post_code: '02650',
        city: 'Espoo',
        state: 'Uusimaa',
        country: 'Finland',
      },
      bankDetails: {
        name: 'Halsey Redmore',
        IBAN: 'FI93943509340534095',
        BIC: 'OKOSDS',
        bank: 'OP',
      },
      love: 'ei',
      carAvailable: true,
      drivingLicense: 'B',
      mobile: '(472) 607-9137',
      email: 'hredmore1@imgur.com',
      currentPlan: 'team',
      status: 'pending',
      avatar: '',
    },
    {
      id: 3,
      fullName: 'Marjory Sicely',
      company: 'Oozz PVT LTD',
      role: 'sairaanhoitaja',
      love: 'ei',
      preferences: ['päivä-työ', 'vain sairaanhoitaja työ'],
      permits: ['rokotus lupa', 'love'],
      birthDate: '28-07-1998',
      gender: 'female',
      languages: ['English', 'Arabic'],
      address: {
        add_line_1: 'Vallikallion kuja 5B',
        add_line_2: '',
        post_code: '02650',
        city: 'Espoo',
        state: 'Uusimaa',
        country: 'Finland',
      },
      bankDetails: {
        name: 'Halsey Redmore',
        IBAN: 'FI93943509340534095',
        BIC: 'OKOSDS',
        bank: 'OP',
      },
      carAvailable: false,
      drivingLicense: '',
      mobile: '(472) 607-9137',
      email: 'msicely2@who.int',
      currentPlan: 'enterprise',
      status: 'accepted',
      avatar: '',
    },
  ],
}
/* eslint-enable */

// ------------------------------------------------
// GET: Return Users
// ------------------------------------------------
mock.onGet('/apps/personel/personel').reply(config => {
  // eslint-disable-next-line object-curly-newline
  const {
    q = '',
    perPage = 10,
    page = 1,
    sortBy = 'id',
    sortDesc = false,
    role = null,
    plan = null,
    status = null,
  } = config.params
  /* eslint-enable */
  const queryLowered = q.toLowerCase()
  const filteredData = data.users.filter(
    user =>
      /* eslint-disable operator-linebreak, implicit-arrow-linebreak */
      (user.fullName.toLowerCase().includes(queryLowered)) &&
      user.role === (role || user.role) &&
      user.love === (plan || user.love) &&
      user.status === (status || user.status),
  )
  /* eslint-enable  */

  const sortedData = filteredData.sort(sortCompare(sortBy))
  if (sortDesc) sortedData.reverse()

  return [
    200,
    {
      users: paginateArray(sortedData, perPage, page),
      total: filteredData.length,
    },
  ]
})

// ------------------------------------------------
// POST: Add new person
// ------------------------------------------------
mock.onPost('/apps/personel/personel').reply(config => {
  // Get event from post data
  const { user } = JSON.parse(config.data)

  // Assign Status
  user.status = 'active'

  const { length } = data.users
  let lastIndex = 0
  if (length) {
    lastIndex = data.users[length - 1].id
  }
  user.id = lastIndex + 1

  data.users.push(user)

  return [201, { user }]
})

// ------------------------------------------------
// GET: Return Single Person
// ------------------------------------------------
mock.onGet(/\/apps\/personel\/personel\/\d+/).reply(config => {
  // Get event id from URL
  let userId = config.url.substring(config.url.lastIndexOf('/') + 1)

  // Convert Id to number
  userId = Number(userId)

  const userIndex = data.users.findIndex(e => e.id === userId)
  const user = data.users[userIndex]

  if (user) return [200, user]
  return [404]
})

// ------------------------------------------------
// POST: Update Single Person
// ------------------------------------------------
mock.onPost(/\/apps\/personel\/personel\/\d+/).reply(config => {
  // Get event id from URL
  let userId = config.url.substring(config.url.lastIndexOf('/') + 1)
  // Convert Id to number
  userId = Number(userId)

  // Get event from post data
  const user = JSON.parse(config.data)
  const item = data.users.find(e => e.id === userId)
  Object.assign(item, user)

  return [200, item]
})

// ------------------------------------------------
// DELETE: Remove Single Person
// ------------------------------------------------
mock.onDelete(/\/apps\/personel\/personel\/\d+/).reply(config => {
  let userId = config.url.substring(config.url.lastIndexOf('/') + 1)
  // Convert Id to number
  userId = Number(userId)

  const itemIndex = data.users.findIndex(e => e.id === userId)
  data.users.splice(itemIndex, 1)
  return [200]
})
